import React, { useState } from 'react';
import './ToolPanel.scss';
import { ChevronLeft } from 'lucide-react';

const ToolPanel = (props) => {

  const [minimized, setMinimized] = useState(false)

  let classname = 'toolpanel p-0 z-10'
  classname += props.visible ? ' visible' : ''
  classname += minimized ? ' minimized' : ''

  return (
    <div className={classname}>
      <div id="minimizer" className="minimizer bg-secondary text-primary flex items-center" onClick={ () => setMinimized(!minimized) }>
        <ChevronLeft></ChevronLeft>
      </div>
      <div className="holder sbar">{props.children}</div>
    </div>
  )

}

export default ToolPanel;
